import * as http from 'axios'
const defaultEndpoint = require('@/endpoint')

export const comprarPlanoComCredito = subscriptionPayload => http.post(defaultEndpoint.urlPayment + '/api/v1/payments/subscription/credit', subscriptionPayload)
export const comprarPlanoComBoleto = subscriptionPayload => http.post(defaultEndpoint.urlPayment + '/api/v1/payments/subscription/boleto', subscriptionPayload)
export const comprarServicoComCredito = paymentPayload => http.post(defaultEndpoint.urlPayment + '/api/v1/payments/purchase/credit', paymentPayload)
export const comprarServicoComBoleto = paymentPayload => http.post(defaultEndpoint.urlPayment + '/api/v1/payments/purchase/boleto', paymentPayload)



// WEBPACK FOOTER //
// ./src/store/payment/services.js